import script from "./UserDetailShop.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserDetailShop.vue?vue&type=script&lang=ts&setup=true"

import "./UserDetailShop.vue?vue&type=style&index=0&id=7588d45e&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7588d45e"]])

export default __exports__